import { Layout } from '../../layout/Layout';
import { NotFoundHero } from './NotFoundHero';

export const NotFoundPage = () => (
  <Layout>
    <NotFoundHero />
  </Layout>
);
